var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length)?_c('ul',{staticClass:"navigation-sub-items"},_vm._l((_vm.items),function(item){return _c('li',{key:item.title},[_c('NavigationSubItem',_vm._b({},'NavigationSubItem',item,false))],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }